import { IconType } from "../../types";
import { Icon } from "./Icon";

type ProductTagProps = {
  title: string;
  description: string;
  icon: {
    name: IconType;
    fill: string;
  };
};

export const ProductTag = ({ title, description, icon }: ProductTagProps) => {
  return (
    <div className="product-tag d-flex flex-column">
      <div className="product-tag__row d-flex flex-row">
        {icon && (
          <Icon
            name={icon.name}
            fill={icon.fill}
            className="product-tag__icon"
            aria-hidden="true"
          />
        )}
        <strong className="product-tag__title mb-0">{title}</strong>
      </div>
      <p className="product-tag__description mb-0">{description}</p>
    </div>
  );
};
